import { SiteLayout } from '../../components/SiteLayout';
import { usePageMeta } from '../../lib/meta';
import { FAQ } from './content';

export function Faq() {
  usePageMeta('FAQ', 'Answers about downloads, YouTube, AI transcription, plans, refunds and your data in Ayonix Studio.');
  return (
    <SiteLayout>
      <div class="container faq" style="max-width:820px">
        <header class="page-hero"><h1>Frequently asked questions</h1><p class="muted">Still stuck? Email <a href="mailto:support@ayonix.com">support@ayonix.com</a>.</p></header>
        {FAQ.map((f) => <details key={f.q}><summary>{f.q}</summary><p>{f.a}</p></details>)}
      </div>
    </SiteLayout>
  );
}
